export default "__VITE_ASSET__DsB94mhI__"